<div class="flex flex-col items-center gap-8 my-12 mx-10">
	<div class="flex justify-center">
		<img
			class="w-52"
			src="/assets/images/leap/contact-admin.png"
			alt="Contact admin to setup billing"
		/>
	</div>

	<div class="flex flex-col items-center gap-5">
		<h1 class="font-medium text-3xl mb-0">Your Trial of Closer has Ended</h1>
		<p>
			To continue, contact one of the following admins to add billing details to
			your account.
		</p>
	</div>

	<div class="w-full">
		<table mat-table [dataSource]="adminUsersDataSource$ | async">
			<ng-container matColumnDef="name">
				<th mat-header-cell *matHeaderCellDef>Admin Name</th>
				<td mat-cell *matCellDef="let adminUser" class="break-all">
					{{ adminUser.name }}
				</td>
			</ng-container>

			<ng-container matColumnDef="email">
				<th mat-header-cell *matHeaderCellDef>Email</th>
				<td mat-cell *matCellDef="let adminUser" class="break-all">
					{{ adminUser.email }}
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
		</table>
	</div>
</div>
